<template>
  <div v-if="isChatEnabled && isChatAllowed">
    <div id="tdWebchat"></div>
  </div>
</template>

<script>
export default {
  props: {
    isChatAllowed: {
      type: Boolean,
      default: false,
    },
    salesforceContactId: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
    resolvedChatMode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      webchat: null,
      isChatEnabled: this.$appConfig.isChatEnabled,
      scriptLoaded: false, // Tracks if the script has been loaded
    };
  },
  mounted() {
    if (this.isChatEnabled && this.isChatAllowed) {
      this.initializeChat();
    }
  },
  beforeUnmount() {
    this.cleanupChat();
  },
  methods: {
    initializeChat() {
      if (this.scriptLoaded) {
        console.warn("TalkdeskChatSDK script already loaded");
        this.initializeWebChat();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js";
      script.async = true;
      script.type = "text/javascript";
      script.charset = "UTF-8";
      script.id = "tdwebchatscript";
      script.onload = () => {
        this.scriptLoaded = true;
        this.initializeWebChat();
      };

      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    },
    initializeWebChat() {
      const touchpointId = this.getTalkdeskTouchpointId();
      
      if (!touchpointId) {
        console.error("Talkdesk touchpoint ID is not configured.");
        return;
      }

      // eslint-disable-next-line no-undef
      this.webchat = TalkdeskChatSDK("tdWebchat", {
        touchpointId,
        accountId: "",
        region: "td-us-1",
      });

      this.webchat.init({
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
        enableValidation: false,
      });

      this.webchat.onConversationStart = this.setContext;
      this.webchat.onOpenWebchat = this.setContext;

      console.log("Webchat initialized");
    },
    getTalkdeskTouchpointId() {
      const humanTouchpointId = this.$appConfig.talkDeskTouchpointId;
      const aiTouchpointId = this.$appConfig.talkDeskAiTouchpointId;

      if (this.resolvedChatMode === "ai_agent") {
        if (aiTouchpointId) {
          return aiTouchpointId;
        }

        console.warn(
          "resolvedChatMode is ai_agent but VUE_APP_TALKDESK_AI_TOUCHPOINT_ID is not set. Falling back to human touchpoint."
        );
      }

      return humanTouchpointId;
    },
    setContext() {
      if (this.webchat) {
        this.webchat.setContextParam({
          contactid: this.salesforceContactId,
          td_contact_person_identification: this.userEmail,
        });
      }
    },    
    cleanupChat() {
      console.log("Cleaning up chat");
      if (this.webchat) {
        try {
          this.webchat.reset();
          console.log("Chat widget reset");
        } catch (error) {
          console.error("Error resetting webchat:", error);
        }
      }
    },
  },
};
</script>
